import React from 'react';
import { cn } from '../../utils/cn';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}
export function Card({
  className,
  children,
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={cn('rounded-lg border border-gray-800 bg-[#1a1d23] text-gray-100 shadow-sm', className)} {...props} data-id="element-347">
      <div className={cn(noPadding ? '' : 'p-6')} data-id="element-348">{children}</div>
    </div>;
}